module.exports = "<aem-web-component-bws-app \r\n  id=\"bws-aem-viewer-xf\"\r\n  path=\"{{path}}\"\r\n  ng-attr-data-aem-host=\"{{restHost}}\"\r\n  ng-attr-data-aem-folder=\"{{folder}}\"\r\n  ng-attr-data-aem-project=\"{{project}}\"\r\n  ng-attr-data-rest-host=\"{{dataHost}}\"\r\n  ng-attr-data-aem-is-partial=\"{{partial}}\"\r\n></aem-web-component-bws-app>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/aem/aem-portal-xf-template.html
 ** module id = 889
 ** module chunks = 1
 **/